<template>
  <div class="yhc-service-level-pickup-date">
    <div class="yhc-service-level-pickup-date__title">
      <a
        href="#"
        class="hover-fade"
        ref="pickupDateDisplay"
        @click.prevent="() => (showDateSelectPopover = !showDateSelectPopover)"
      >
        <ficon
          type="calendar"
          style="font-size: 1.2em"
        />
        お預かり日を選択
      </a>
      <b-popover
        :target="() => $refs.pickupDateDisplay"
        ref="pickupDatePopover"
        hide-footer
        v-model="showDateSelectPopover"
        placement="bottom"
        custom-class="popover-body-no-padding"
        :manual="true"
        title=""
      >
        <datepicker
          class="border-0"
          :model-value="
            $yhcefs.$userInputData.pickupSelectedDate ||
            $yhcefs.$userInputData.minPickupNeedDate
          "
          @update:model-value="onPickupDateSelected"
          :inline="true"
          :min-date="minPickupDate"
          :disabled-dates="disabledDates"
        />
      </b-popover>
    </div>
    <div class="yhc-service-level-pickup-date__content">
      <div class="yhc-service-level-pickup-date__date">
        {{ pickupDateDisplayLabelWithWeekday }}
      </div>
      <!-- リセットフラグがtrueの場合に警告メッセージを表示 -->
      <div
        v-if="$yhcefs.$userInputData.pickupDateResetFlag"
        class="pickup-date-warning"
      >
        ※お預かり日を選択してください
      </div>
      <!-- 過去日を選択している場合に注釈を表示 -->
      <div
        v-if="isPastDateSelected"
        class="pickup-date-warning"
      >
        ※過去日を選択しています。最短お預かり日は{{ minPickupDateFormatted }}です。
      </div>
      <!-- <div
        v-if="canCalcDate && !isSameDayDelivery && !deliveryPeakSeasonRule"
        class="yhc-service-level-pickup-date__desc"
      >
        当日18時までの事前予約で、最短翌日のお預かりが可能です。<br />
        18時以降のご予約は、翌々日からのお預かりとなります。<br />
        引越シーズン期間や
        Web申し込みの場合は、最短の日付よりもお預かり・配達にプラス1日いただきます。
      </div> -->
      <!-- <div
        v-if="deliveryPeakSeasonRule"
        class="yhc-service-level-pickup-date__desc"
      >
        <span class="warning"
          >{{ formatDateForMD(deliveryPeakSeasonRule.startDate) }} ～
          {{ formatDateForMD(deliveryPeakSeasonRule.endDate) }}</span
        >は引越シーズン期間につき多くのお客様にご利用いただいております。
        すべてのお客様に変わらぬサービス品質をお届けするため、以下の対応とさせていただきます。
        <ul>
          <li>
            シーズン加算料金として<span class="warning"
              >+ ¥{{ deliveryPeakSeasonRule.additionalPrice.toLocaleString() }}</span
            >
            (税込) /件が発生します。
          </li>
          <li>
            通常よりお預かりにかかる日数を
            <span class="warning">+{{ deliveryPeakSeasonRule.additionalLeadDays }}日 </span
            >いただきます。
          </li>
          <li v-if="hasDeliverableItemCountsLimit(deliveryPeakSeasonRule)">
            同一日に同一住所の配送可能数
            <span class="warning"
              >{{ deliveryPeakSeasonRule.deliverableItemCounts }}点 </span
            >までとなります。
          </li>
          <li>当日15時までの事前予約で、最短翌々日のお預かりが可能です。</li>
          <li v-if="deliveryPeakSeasonRule.sameDayDeliveryDisabled">
            お預かり日当日の配達はご利用いただけません。
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>

<script lang="ts">
import { YhcEstimateFormFrontService } from '../../YhcEstimateFormFrontPage/YhcEstimateFormFrontService'
import { ModelYhcKazaiDeliveryPeakSeasonRules } from '../../../fireModels/yhcDataTypes'
import { formatDateWithWeekday } from '../utils/dateFormatter'

export default {
  name: 'YhcServiceLevelPickupDate',
  inject: ['YhcEstimateFormFrontServiceInstance'],
  data() {
    return {
      showDateSelectPopover: false,
    }
  },
  computed: {
    $yhcefs(): YhcEstimateFormFrontService {
      return this.YhcEstimateFormFrontServiceInstance
    },
    /** お預かり日表示（お届け日選択と同様の YYYY年M月D日(曜) 形式。日付ありかつリセットでないときのみ曜日付き） */
    pickupDateDisplayLabelWithWeekday(): string {
      const u = this.$yhcefs.$userInputData
      if (
        u.pickupSelectedDate &&
        !u.pickupDateResetFlag &&
        !u.pickupDateDisplayErrorMessage
      ) {
        return formatDateWithWeekday(u.pickupSelectedDate)
      }
      return u.pickupDateDisplayLabel || ''
    },
    canCalcDate(): boolean {
      return (
        this.$yhcefs.$userInputData.pickupDateDisplayLabel.indexOf('年') >= 0 ||
        this.$yhcefs.$userInputData.pickupDateResetFlag
      )
    },
    enableSameDayDelivery(): boolean {
      return (
        !this.$yhcefs.isFleaMarket &&
        this.$yhcefs.$userInputData.sameDayPickupAndDeliveryAvailable &&
        !this.$yhcefs.$userInputData.deliveryPeakSeasonRule?.sameDayDeliveryDisabled
      )
    },
    deliveryPeakSeasonRule(): ModelYhcKazaiDeliveryPeakSeasonRules | undefined {
      // お預かり日～お届け日が繁忙期シーズンルールの開始日～終了日に含まれていれば、そのルールマスタを返す
      return this.$yhcefs.$userInputData.deliveryPeakSeasonRule
    },
    minPickupDate() {
      // フリマ用ページの場合は最小日付制限を適用、それ以外は過去日も選択可能
      return this.$yhcefs.isFleaMarket
        ? this.$yhcefs.$userInputData.minPickupNeedDate
        : undefined
    },
    isPastDateSelected(): boolean {
      // フリマ用ページの場合は過去日選択の判定をしない
      if (this.$yhcefs.isFleaMarket) {
        return false
      }
      // お預かり日が選択されており、かつ最短お預かり日より前の場合
      const selectedDate = this.$yhcefs.$userInputData.pickupSelectedDate
      const minDate = this.$yhcefs.$userInputData.minPickupNeedDate
      if (!selectedDate || !minDate) {
        return false
      }
      return $core.$dayjs(selectedDate).isBefore($core.$dayjs(minDate), 'day')
    },
    minPickupDateFormatted(): string {
      const minDate = this.$yhcefs.$userInputData.minPickupNeedDate
      if (!minDate) {
        return ''
      }
      return $core.$dayjs(minDate).format('M月D日')
    },
    disabledDates() {
      const uid = this.$yhcefs.$userInputData
      void this.$yhcefs.masterVersionPeriods
      void uid.fromWorkingDayPatternByVersionId
      void uid.regularWorkingDayRecords
      void uid.fixed_holidays
      void this.$yhcefs.isFleaMarket
      return (date) => uid.isPickupCalendarDateDisabled(date)
    },
  },
  methods: {
    async onPickupDateSelected(value: string | Date | null) {
      this.$yhcefs.$userInputData.pickupSelectedDate = value
        ? $core.$dayjs(value).format('YYYY-MM-DD')
        : null
      this.$yhcefs.$userInputData.pickupDateResetFlag = false
      await this.$yhcefs.$userInputData.refreshMastersForSelectedDates()
      this.showDateSelectPopover = false
    },
    // 日付を表示用フォーマットに変換する関数（曜日付き）
    formatDateForDisplay(dateStr: string): string {
      return formatDateWithWeekday(dateStr)
    },
  },
}
</script>

<style lang="scss" scoped>
.yhc-service-level-pickup-date {
  padding: 8px 16px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;

  &__title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 4px;
    color: var(--yhc-color);
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__date {
    font-size: 16px;
    font-weight: 500;
    word-wrap: break-word;
  }

  &__desc {
    font-size: 14px;
    color: #666;
    margin-top: 8px;
    text-align: left;
    line-height: 1.5;
  }

  .warning {
    font-weight: bold;
    color: #ff4500;
  }

  .pickup-date-warning {
    color: red;
    font-size: 14px;
    margin-top: 5px;
  }

  @media screen and (max-width: 767px) {
    padding: 6px 10px;
    width: 100%; // スマホでは100%幅

    &__title {
      font-size: 16px;
      margin-bottom: 6px;
    }

    &__date {
      font-size: 15px;
      word-break: break-word;
    }

    &__desc {
      font-size: 12px;
    }
  }
}
</style>
